// @flow
import React, {type Node} from 'react';
import styled from 'styled-components';

const ProtocolWarningIcon = (): Node => (
  <Wrapper>
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.67773 16.7134C9.77293 16.7131 9.85306 16.7847 9.86328 16.8794C9.87145 16.9486 9.87518 17.0187 9.875 17.0884C9.875 18.1239 9.03553 18.9634 8 18.9634C6.96459 18.9632 6.125 18.1238 6.125 17.0884C6.12482 17.0187 6.12952 16.9486 6.1377 16.8794C6.14861 16.785 6.22812 16.7136 6.32324 16.7134H9.67773ZM8 0.963379C8.62132 0.963379 9.125 1.46706 9.125 2.08838V2.93994C9.74829 3.05134 10.3438 3.28536 10.876 3.62842C12.7313 4.93454 13.8175 7.07664 13.7754 9.34521V9.92139C13.7781 11.831 14.2268 13.7135 15.085 15.4194C15.1435 15.5356 15.1374 15.6739 15.0693 15.7847C15.0012 15.8955 14.8801 15.9632 14.75 15.9634H1.25C1.12021 15.963 0.999721 15.8952 0.931641 15.7847C0.863707 15.6741 0.857883 15.5364 0.916016 15.4204C1.77437 13.7143 2.22285 11.8313 2.22559 9.92139V9.34521C2.19155 7.24493 3.11605 5.24335 4.7373 3.90771C5.36508 3.42551 6.09724 3.09704 6.875 2.94971V2.08838C6.875 1.46715 7.3788 0.96352 8 0.963379Z"
        fill="#121419"
      />
    </svg>
  </Wrapper>
);

const Wrapper = styled.div`
  flex-shrink: 0;
  align-self: center;
`;

export default ProtocolWarningIcon;
